import React from 'react';

export type CharacterVariant = 'clapboard' | 'phone' | 'reader' | 'laptop-duo';
export type CharacterTone = 'cream' | 'yellow' | 'original';

export interface BrandCharacterProps {
  /** Which character variant to render. PNG files live in /brand/. */
  which?: CharacterVariant;
  /** Height in px. Width auto-scales. */
  size?: number;
  /** Recoloring filter applied to the (originally black) line art:
   *  - `cream`: cream on dark surfaces (default — most uses)
   *  - `yellow`: yellow (for joe-direction accents — kept for future use)
   *  - `original`: leave black-on-transparent (use on beige) */
  tone?: CharacterTone;
  className?: string;
  style?: React.CSSProperties;
}

/** Brand character illustration. Real brand line-art PNGs (black on
 *  transparent). The `tone` prop applies a CSS filter to retint for use on
 *  dark surfaces. On beige, use `tone="original"`. */
export const BrandCharacter: React.FC<BrandCharacterProps> = ({
  which = 'clapboard',
  size = 200,
  tone = 'cream',
  className,
  style,
}) => {
  const filter =
    tone === 'cream'
      ? 'invert(95%) sepia(8%) saturate(280%) hue-rotate(0deg) brightness(98%)'
      : tone === 'yellow'
        ? 'invert(86%) sepia(76%) saturate(1800%) hue-rotate(2deg) brightness(102%) contrast(98%)'
        : 'none';
  return (
    <img
      src={`/brand/char-${which}.png`}
      alt=""
      aria-hidden="true"
      className={className}
      style={{
        height: size,
        width: 'auto',
        pointerEvents: 'none',
        display: 'block',
        filter,
        ...style,
      }}
    />
  );
};
